import Head from './Head'
import PageHead from './PageHead'
import Title from './Title'

export default Head
export { PageHead, Title }
